import { render, staticRenderFns } from "./SplitActionDropdown.vue?vue&type=template&id=c4752414"
import script from "./SplitActionDropdown.vue?vue&type=script&lang=js"
export * from "./SplitActionDropdown.vue?vue&type=script&lang=js"
import style0 from "./SplitActionDropdown.vue?vue&type=style&index=0&id=c4752414&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports